import { stepList } from '../list/steps';

export const howToWork = {
  title: 'Как это работает?',
  list: stepList,
};
